const defaultState = () => {
  return {
    selectedImage: null,
    isDialogOpen: false
  };
};

// Load persisted state from localStorage
const loadPersistedState = () => {
  try {
    const persistedData = localStorage.getItem('images-editor-state');
    if (persistedData) {
      const parsed = JSON.parse(persistedData);
      return {
        selectedImage: parsed.selectedImage || null,
        isDialogOpen: false // Don't persist dialog open state
      };
    }
  } catch (error) {
    console.warn('Failed to load persisted images editor state:', error);
  }
  return defaultState();
};

// Save state to localStorage
const saveStateToStorage = state => {
  try {
    // Only persist essential image data, not file objects
    const persistData = {
      selectedImage: state.selectedImage
        ? {
            id: state.selectedImage.id,
            url: state.selectedImage.url,
            optimized_url: state.selectedImage.optimized_url,
            preview_url: state.selectedImage.preview_url,
            name: state.selectedImage.name,
            size: state.selectedImage.size,
            type: state.selectedImage.type,
            // Don't persist file object as it can't be serialized
            file: null
          }
        : null
    };
    localStorage.setItem('images-editor-state', JSON.stringify(persistData));
  } catch (error) {
    console.warn('Failed to save images editor state:', error);
  }
};

const imagesEditor = {
  namespaced: true,
  state: loadPersistedState(),
  mutations: {
    resetState(state) {
      Object.assign(state, defaultState());
      saveStateToStorage(state);
    },
    setSelectedImage(state, image) {
      state.selectedImage = image;
      saveStateToStorage(state);
    },
    setDialogOpen(state, isOpen) {
      state.isDialogOpen = isOpen;
      // Don't persist dialog state to storage
    },
    clearImagesEditorState(state) {
      state.selectedImage = null;
      state.isDialogOpen = false;
      saveStateToStorage(state);
    }
  },
  actions: {
    resetState({ commit }) {
      commit('resetState');
    },
    setSelectedImage({ commit }, image) {
      commit('setSelectedImage', image);
    },
    setDialogOpen({ commit }, isOpen) {
      commit('setDialogOpen', isOpen);
    },
    clearImagesEditorState({ commit }) {
      commit('clearImagesEditorState');
    },
    openImagesEditor({ commit }, image = null) {
      if (image) {
        commit('setSelectedImage', image);
      }
      commit('setDialogOpen', true);
    },
    // Action to manually save state (useful for external calls)
    saveState({ state }) {
      saveStateToStorage(state);
    }
  },
  getters: {
    getSelectedImage: state => state.selectedImage,
    getIsDialogOpen: state => state.isDialogOpen,
    getHasSelectedImage: state => !!state.selectedImage
  }
};

export default imagesEditor;
